package com.narbase.letsgo.web.views.banners

import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.dimen
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.drawable.Color
import com.narbase.kunafa.core.lifecycle.LifecycleOwner
import com.narbase.letsgo.web.common.AppColors
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.horizontalFiller
import com.narbase.letsgo.web.utils.scrollable.scrollable
import com.narbase.letsgo.web.utils.table.headerCell
import com.narbase.letsgo.web.utils.table.listTable
import com.narbase.letsgo.web.utils.table.tableCell
import com.narbase.letsgo.web.utils.table.tableRow
import com.narbase.letsgo.web.utils.verticalSeparator
import com.narbase.letsgo.web.utils.views.*

class BannersManagementComponent : Component() {

    private var paginationControls: PaginationControls? = null
    private val viewModel = BannersManagementViewModel()

    private var listTableBody: View? = null

    private val upsertBannerDialog = UpsertBannerDialog {
        viewModel.getBanners()
    }

    override fun onViewMounted(lifecycleOwner: LifecycleOwner) {
        super.onViewMounted(lifecycleOwner)
        viewModel.getBanners()
    }

    private fun onListLoaded() {
        paginationControls?.update(viewModel.pageNo, viewModel.pageSize, viewModel.total)
        listTableBody?.clearAllChildren()
        listTableBody?.apply {
            viewModel.banners.forEachIndexed { index, item ->
                tableRow {
                    style {
                        alignItems = Alignment.Center
                        paddingEnd = 8.px
                    }
                    tableCell(item.title.ifBlank { "N/A" }, 1, 14.px)
                    tableCell(item.description.ifBlank { "N/A" }, 2, 14.px)
                    tableCell(if (item.isActive) "Active".localized() else "Not active".localized(), 1, 14.px)
                    deleteIcon {
                        item.id?.let {
                            showRemoteDeleteConfirmationDialog(
                                message = "Are you sure you want to delete this item?".localized(),
                                uiState = viewModel.upsertUiState,
                                action = { viewModel.deleteItem(it) },
                                onDeleted = { viewModel.getBanners() }
                            )
                        }
                    }
                    onClick = {
                        upsertBannerDialog.edit(item)
                    }
                }

                if (index != viewModel.banners.lastIndex) {
                    verticalSeparator()
                }
            }
        }
    }

    override fun View?.getView() = view {
        id = "bannersManagementRootView"
        style {
            matchParentDimensions
        }
        scrollable {
            style {
                matchParentDimensions
            }

            verticalLayout {
                style {
                    width = matchParent
                    height = wrapContent
                    padding = 32.px
                }

                horizontalLayout {
                    style {
                        width = matchParent
                    }
                    textView {
                        text = "Banners Management".localized()
                        style {
                            width = wrapContent
                            fontSize = 20.px
                            fontWeight = "bold"
                        }
                    }

                    horizontalFiller()

                    addBannerButton()

                }

                horizontalLayout {
                    style {
                        width = matchParent
                        marginTop = 16.px
                    }
                    horizontalFiller()
                    searchTextInput("Search".localized()) {
                        viewModel.searchFor(it)
                    }
                }

                verticalLayout {
                    matchParentDimensions()
                    withLoadingAndError(viewModel.getBannersUiState,
                        onRetryClicked = { viewModel.getBanners() },
                        onLoaded = { onListLoaded() })

                    listTableBody = listTable {
                        headerCell("Title".localized(), 1)
                        headerCell("Description".localized(), 2)
                        headerCell("Is Active".localized(), 1)
                        headerCell("".localized(), { 24.px })
                    }
                    paginationControls = setupPaginationControls(viewModel::getNextPage, viewModel::getPreviousPage)
                }
            }
        }
    }

    private fun LinearLayout.addBannerButton() {
        textView {
            style {
                color = Color.white
                padding = "2px 12px".dimen()
                backgroundColor = AppColors.mainColor
                borderRadius = 12.px
                pointerCursor()
                hover {
                    backgroundColor = AppColors.mainDarkColor
                }
            }

            onClick = {
                upsertBannerDialog.add()
            }

            id = "AddBannerButton"
            text = "+ Add new banner".localized()
        }
    }
}
